import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { PDFDocument } from "pdf-lib";
import Form from "../Components/Form";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase.config";
import { storage } from "../firebase.config";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { v4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { formatDateString, slugify } from "../utils/helperFunctions";
import EditForm from "../Components/EditForm";
import { setLoading } from "../Redux/Loader/loadingSlice";

const Edit = ({
  pdfExhibit,
  setPdfExhibit,
  currentDate,
  imgExhibit,
  setImgExhibit,
  setReviewExhibitID,
  exhibit,
}) => {
  const user = useSelector((state) => state.user);
  const [pdfURL, setPdfURL] = useState(null);
  const navigate = useNavigate();
  const propertyTypeSelector = (propertyType) => {};
  const newDate = new Date();
  const timeStamp = newDate.toJSON().replaceAll(":", "-").replaceAll(".", "-");
  const sluggedCompany = slugify(user.companyName);
  const [imageUpload, setImageUPload] = useState(null);
  const [fileUploads, setFileUploads] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const imagePath = `${sluggedCompany}/images/${imageUpload?.name + v4()}`;
  const [progress, setProgress] = useState(0);
  const uploadImage = () => {};
  const dispatch = useDispatch();
  useEffect(() => {
    console.log(auth.currentUser);
    if (!auth.currentUser) navigate("/");
  }, []);

  async function fillForm(exhibitDataForm, status) {
    console.log("FILL FORM DATA (UI-only, no DB writes)", exhibitDataForm);

    // --- 1) Build the PDF in-memory from the form data ---
    const formUrl =
      "https://www.mlinc.collinicoding.com/ComplyOfficeExhibit.pdf";
    const formPdfBytes = await fetch(formUrl).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(formPdfBytes);
    const form = pdfDoc.getForm();

    // Map fields
    const serviceProviderLessor = form.getTextField("Service Provider Lessor");
    const commonName = form.getTextField("Common/Branded Name");
    const address = form.getTextField("Location Address");
    const city = form.getTextField("City");
    const state = form.getTextField("State");
    const zipCode = form.getTextField("Zip Code");
    const description = form.getTextField("Additional Description");
    const startDate = form.getTextField("Expected Start Date");
    const sqftLeased = form.getTextField("Square Feet Leased");
    const expectedTerm = form.getTextField("Expected Term of Lease");
    const numberOfDesks = form.getTextField("Number of Desks/Workstations");
    const companyName = form.getTextField("Company Lessee");
    const signature = form.getField("Signature");
    const signDate = form.getField("Date Signed");

    const office = form.getCheckBox("Office");
    const industrial = form.getCheckBox("Industrial/Warehouse");
    const retail = form.getCheckBox("Retail");
    const mixed = form.getCheckBox("Mixed/Other");
    const privateOffice = form.getCheckBox("Private Office");
    const cubicle = form.getCheckBox("Cubicle");
    const interior = form.getCheckBox("Interior");
    const exterior = form.getCheckBox("Exterior/Window");
    const cam = form.getCheckBox("Common area maintenance");
    const furnishings = form.getCheckBox("Furniture and furnishings");
    const janitorial = form.getCheckBox("Janitorial");
    const parking = form.getCheckBox("Parking");
    const insurace = form.getCheckBox("Property insurance and taxes");
    const electirc = form.getCheckBox("Electricity");
    const gas = form.getCheckBox("Gas/Oil/Propane");
    const water = form.getCheckBox("Water");
    const phone = form.getCheckBox("Phone");
    const internet = form.getCheckBox("Internet/WiFi");
    const conference = form.getCheckBox("Furnished conference room(s) use");
    const kitchen = form.getCheckBox("Kitchen");
    const copyFax = form.getCheckBox("Copy/fax/printer/scanner use");
    const receptionist = form.getCheckBox("Receptionist/Answering");

    // Fill text fields
    serviceProviderLessor.setText(exhibitDataForm.serviceProvider || "");
    commonName.setText(exhibitDataForm.commonName || "");
    address.setText(exhibitDataForm.locationAddress || "");
    city.setText(exhibitDataForm.city || "");
    state.setText(exhibitDataForm.state || "");
    zipCode.setText((exhibitDataForm.zipcode ?? "").toString());
    sqftLeased.setText((exhibitDataForm.sqftLeased ?? "").toString());
    description.setText(exhibitDataForm.description || "");
    startDate.setText(exhibitDataForm.startDate || "");
    expectedTerm.setText(exhibitDataForm.term || "");
    numberOfDesks.setText((exhibitDataForm.desks ?? "").toString());

    // Company/signature metadata from Redux user + currentDate props
    companyName.setText(user.companyName || "");
    signature.setText(
      `${user.contactFirstName} ${user.contactLastName}`.trim()
    );
    signDate.setText(formatDateString(currentDate) || "");

    // Checkboxes for radios/sets
    switch (exhibitDataForm.propertyType) {
      case "Office":
        office.check();
        break;
      case "Industrial/Warehouse":
        industrial.check();
        break;
      case "Retail":
        retail.check();
        break;
      case "Mixed/Other":
        mixed.check();
        break;
    }

    switch (exhibitDataForm.spaceType) {
      case "Private office":
        privateOffice.check();
        break;
      case "Cubicle":
      case "cubicle":
        cubicle.check();
        break;
    }

    switch (exhibitDataForm.settingType) {
      case "Interior":
        interior.check();
        break;
      case "Window":
        exterior.check();
        break;
    }

    (exhibitDataForm.facility || []).forEach((item) => {
      switch (item) {
        case "cam":
          cam.check();
          break;
        case "furnished":
          furnishings.check();
          break;
        case "janitorial":
          janitorial.check();
          break;
        case "parking":
          parking.check();
          break;
        case "tax":
          insurace.check();
          break;
      }
    });

    (exhibitDataForm.utility || []).forEach((item) => {
      switch (item) {
        case "electricity":
          electirc.check();
          break;
        case "gas":
          gas.check();
          break;
        case "water":
          water.check();
          break;
        case "phone":
          phone.check();
          break;
        case "internet":
          internet.check();
          break;
      }
    });

    (exhibitDataForm.amenity || []).forEach((item) => {
      switch (item) {
        case "meeting":
          conference.check();
          break;
        case "kitchen":
          kitchen.check();
          break;
        case "copy":
          copyFax.check();
          break;
        case "receptionist":
          receptionist.check();
          break;
      }
    });

    // --- 2) Save the filled PDF and upload to Storage ---
    const pdfBytes = await pdfDoc.save();
    const newFile = new File([pdfBytes], "ComplyOfficeExhibit.pdf", {
      type: "application/pdf",
    });

    const timeStamp = new Date()
      .toJSON()
      .replaceAll(":", "-")
      .replaceAll(".", "-");
    const sluggedCompany = slugify(user.companyName);
    const pdfRef = ref(
      storage,
      `${sluggedCompany}/pdfs/complyOfficeExhibit-${timeStamp}.pdf`
    );

    const pdfURL = await new Promise((resolve, reject) => {
      const task = uploadBytesResumable(pdfRef, newFile);
      task.on(
        "state_changed",
        (snap) => {
          const pct = Math.round(
            (snap.bytesTransferred / snap.totalBytes) * 100
          );
          console.log(`PDF upload is ${pct}% done`);
          setProgress?.(pct);
        },
        (err) => reject(err),
        async () => resolve(await getDownloadURL(task.snapshot.ref))
      );
    });
    console.log("PDF is now available at", pdfURL);

    // --- 3) Upload any new photos selected in this edit session (optional) ---
    // Keep whatever URLs were already on the doc, and append newly uploaded ones.
    let latestFileUrls = Array.isArray(exhibitDataForm.fileUrls)
      ? [...exhibitDataForm.fileUrls]
      : [];

    if (Array.isArray(fileUploads) && fileUploads.length) {
      const uploadedUrls = await Promise.all(
        fileUploads.map(async (file, idx) => {
          const fileName = file.name || file.label || `file_${idx}`;
          const storageRef = ref(
            storage,
            `${sluggedCompany}/uploads/${fileName}`
          );
          // Upload
          await new Promise((resolve, reject) => {
            const up = uploadBytesResumable(storageRef, file);
            up.on(
              "state_changed",
              (snap) => {
                const pct = Math.round(
                  (snap.bytesTransferred / snap.totalBytes) * 100
                );
                console.log(`Upload #${idx + 1} is ${pct}% done`);
              },
              (err) => reject(err),
              () => resolve()
            );
          });
          // Return URL
          return await getDownloadURL(storageRef);
        })
      );

      latestFileUrls = [...latestFileUrls, ...uploadedUrls];
      console.log("Final EXHIBIT URLS:", latestFileUrls);
    }

    // --- 4) Return values to EditForm so it can do ONE Firestore write ---
    return { pdfURL, fileUrls: latestFileUrls };
  }

  return (
    <div>
      <EditForm
        exhibit={exhibit}
        uploadImage={uploadImage}
        imageUpload={imageUpload}
        setImageUPload={setImageUPload}
        setFileUploads={setFileUploads}
        fileUploads={fileUploads}
        setFileUrls={setFileUrls}
        fileUrls={fileUrls}
        currentDate={currentDate}
        fillForm={fillForm}
        setReviewExhibitID={setReviewExhibitID}
      />
    </div>
  );
};

export default Edit;
